import React from 'react'
// import app from './koko-framework/app'
// import main from './main'
import { moreInfoController } from './Bootstrap';
import { fb, tw } from './koko-framework/social'

export default class ShareHtmlPop extends React.Component {
    /* constructor(props) {
        super(props);
    } */

    render() {
        // if (this.props.open) {
            let showList = this.props.fadeIn ? 'show' : '';
            if (this.props.fadeOut === true) {
                showList = 'fade-out';
            }
            let classList = 'blackout ' + showList;
            return (
                <div className={classList}>
                    <div className="share-content-container">
                    <div className="share-content-inner">
                        <div className="close-button-sh" onClick={moreInfoController.hideSharePop} />
                        <div className="share-text">Share this game using the<br />buttons below!</div>
                        <div className="share-buttons-holder">
                            <img className="share-button" src="./img/twitter_btn.png" onClick={this.twitterShare} alt="" />
                            <img className="share-button" src="./img/fb_btn.png" onClick={this.fbShare} alt="" />
                        </div>
                    </div>
                </div>   
                </div>
            );
        // }
        // return null;
    }

    twitterShare = () => {
        tw.share_simple(window.SHARE_MESSAGE, window.SHARE_HASH_TAGE, window.SHARE_URL);
    }

    fbShare = () => {
        fb.share_ui(window.SHARE_MESSAGE, window.SHARE_HASH_TAGE, window.SHARE_URL);
    }
}